module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADWSURBVHgB3dOxDYMwEAVQG6egZAS2ALqwSUZghDBBskGyCW6QoMoKzgaeAPJPguggRAKbii9ZWKfj6QyyEIdNkiRFmqbxvB4IhwB6SClv2FZzVIqNIaDv+xfAaCgZrLxpGrN5wizLaCrRdV0O1A7lGOs89qwG6ZhACmwrpZRlaInpnmPfqiMThseFlQxWHoah1Vpb3qscMEqE6d51Xet5f+CAUcq2be9L70gXDN/s+u89uSe2CPpgP6AvRvn+FLqbvtgEZFfJGZuAe2CUE9trtjf8Oh0rH3NxYQpP1hpfAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/Images/baselineimgedit.png
// module id = 1146
// module chunks = 0